export default "__VITE_ASSET__BF$B_bVL__"